import { useEffect, useState } from 'react';
import ResumoDepartamento from "./ResumoDepartamento";
import ResumoStatus from "./ResumoStatus";
import { formatLocalDate, getComecoAno, getDataSeteDiasAntesFormatado, getHojeFormatado, getMesAtual, getMesPassado, ultimoDiaMesPassado } from "../../../../utils/formatDate";
import ResumoPorFilial from "./ResumoPorFilial";
import TabelaSolicitacoes from "./TabelaSolicitacoes";
import { Loading } from "../../../../componentes/loading/loading";
import DropDown from "../../../../componentes/dropdown/dropdown";
import InputForm from "../../../../componentes/input/input";
import { toast } from "react-toastify";
import FluigDespesaService from "../../../../services/resource/fluigDespesasService";
import SolicitcoesPorFaixaPreco from "./SolicitcoesPorFaixaPreco";
import RankingDepartamentos from './RankingDepartamentos';
import ResumoSolicitantes from './ResumoSolicitantes';
import { formatarMoedaBrasileira } from '../../../../utils/formatarMoedaBrasileira';
import { intervaloDatas } from '../../../../utils/options';
import DespesaPorMes from './DespesaPorMes';
import SplitButton from '../../../../componentes/button-split/SplitButton';
import { exportaComQualidade } from '../../../../utils/exportarDashboardEmPDF';
import { captureElementToImage } from '../../../../utils/captureElementToImage';
import { copyElementToClipboard } from '../../../../utils/copyElementToClipboard';
import Button from '../../../../componentes/button/button';

const initialDespesas = {
    "countByStatus": {
        "Finalizado": null,
        "Aberto": null,
        "Cancelado": null,
    },
    "valorTotal": null,
    "resultadoSomaDTO": {
        "porFilial": {
            "Piripiri": null,
            "Caxias": null,
            "Picos": null,
            "Floriano": null,
            "Teresina": null,
            "todas": null,
            "SRN": null,
        },
        "porSetor": {
            "LOGISTICA": null,
            "TI": null,
            "RH": null,
            "Financeiro": null,
        }
    },
    "faixa": {
        "500-1000": null,
        "<500": null,
        ">1000": null
    },
    "mediaPagamento": {
        "transferencia": null,
        "boleto": null,
        "cartao_de_credito": null
    },
    "totalPagamento": {
        "transferencia": null,
        "boleto": null,
        "cartao_de_credito": null
    },
    "topDepartamentos": {
        "RH": null,
        "LOGISTICA": null,
        "TI": null,
        "Financeiro": null,
    },
    "totalSoliciatntes": {
        "email@email.com": ""
    },
    "solicitacoes": [
        {
            "cardId": null,
            "documentId": null,
            "version": null,
            "filial": "",
            "setor": "",
            "cargo": "",
            "descricaoDespesa": "",
            "valorDespesa": null,
            "tipoPagamento": "",
            "vencimento": "",
            "numeroProcesso": null,
            "dataInicio": "",
            "dataEncerramento": "",
            "status": "Cancelado",
            "matriculaRequisitante": "",
            "solicitanteEmail": ""
        },
    ]
}

function RelatorioDespesa() {
    const despesaService = new FluigDespesaService();
    const [despesas, setDespesas] = useState(initialDespesas);
    const [loading, setLoading] = useState(false);
    const [solicitante, setSolicitante] = useState(localStorage.getItem('solicitante') || '');
    const [departamento, setDepartamento] = useState(localStorage.getItem('departamento') || '');
    const [status, setStatus] = useState(localStorage.getItem('status') || '');
    const [filial, setFilial] = useState(localStorage.getItem('filial') || '');
    const [faixa, setFaixa] = useState(localStorage.getItem('faixa') || '');
    const [dataInicial, setDataInicial] = useState(getMesAtual());
    const [dataFinal, setDataFinal] = useState(getHojeFormatado());
    const [filtro, setFiltro] = useState(false);
    const [filtrar, setFiltrar] = useState(false);
    const [dataSelecionada, setDataSelecionada] = useState(7);

    useEffect(() => {
        setLoading(true);

        despesaService.relatorioDespesas(dataInicial, dataFinal, solicitante, departamento, status, filial, faixa).then(response =>
            setDespesas(response.data)
        ).catch(error => {
            console.error("Error: ", error)
        }).finally(() => {
            setLoading(false)
        });
    }, [filtrar]);

    useEffect(() => {
        document.title = "MyDash | Lançamento de Despesas"
    }, []);

    const changeSolicitante = (value) => {
        localStorage.setItem('solicitante', value);
        setSolicitante(value);
        setFiltrar(!filtrar)
    }

    const changeDepartamento = (value) => {
        localStorage.setItem('departamento', value);
        setDepartamento(value);
        setFiltrar(!filtrar)
    }

    const changeStatus = (value) => {
        localStorage.setItem('status', value);
        setStatus(value);
        setFiltrar(!filtrar)
    }

    const changeFilial = (value) => {
        localStorage.setItem('filial', value);
        setFilial(value);
        setFiltrar(!filtrar)
    }

    const changeFaixa = (value) => {
        localStorage.setItem('faixa', value);
        setFaixa(value);
        setFiltrar(!filtrar)
    }

    const mudarPeriodoDeDatas = (e) => {
        const valor = e.target.value;
        setDataSelecionada(valor);
        
        if (valor === 14) {
            setFiltro(true);
            return // abre o filtro
        } else if (valor === 7) {
            setFiltro(false);
            setDataInicial(getMesAtual());
            setDataFinal(getHojeFormatado());
        } else if (valor === 30) {
            setFiltro(false);
            setDataInicial(getMesPassado());
            setDataFinal(ultimoDiaMesPassado());
        } else if (valor === 365) {
            setDataInicial(getComecoAno());
            setDataFinal(getHojeFormatado());
            setFiltro(false);
        } else {
            setFiltro(false);
            setDataInicial(getDataSeteDiasAntesFormatado(valor))
        }

        setFiltrar(!filtrar)
    }

    const FileDownload = require('js-file-download');
    const exportarExcel = () => {
        despesaService.exportarExcel(dataInicial, dataFinal, solicitante, departamento, status, filial, faixa).then(response => {
            const date = new Date();
            FileDownload(response.data, "Lançamento de Despesas " + date.getTime() + ".xlsx");
        }).catch(error => {
            console.error(error)
        })
    }

    return (
        <main className="container  px-4 py-6">
            <div className="bg-card border border-border rounded-lg shadow-card p-4 mb-6">
                <div className="flex flex-wrap justify-between items-end">
                    <div className="flex md:flex-nowrap sm:flex-nowrap lg:flex-nowrap gap-3 fade-in mb-2">
                        <DropDown optional label="Período"
                            options={intervaloDatas}
                            optionLabel="label"
                            optionValue="value"
                            onChange={mudarPeriodoDeDatas}
                            value={dataSelecionada}
                            className="w-60"
                        />

                        {filtro &&
                            <div className='flex md:flex-nowrap sm:flex-nowrap lg:flex-nowrap gap-3 fade-in mb-2'>
                                <InputForm label="Data Inicial" type="date" onChange={e => setDataInicial(e.target.value)} value={dataInicial} className="h-10 px-3 py-2 border border-input rounded-lg focus:ring-2 focus:ring-primary/40 focus:border-primary" />
                                <InputForm label="Data Final" type="date" onChange={e => setDataFinal(e.target.value)} value={dataFinal} className="h-10 px-3 py-2 border border-input rounded-lg focus:ring-2 focus:ring-primary/40 focus:border-primary" />
                                <Button
                                    label="Filtrar"
                                    className="mt-4"
                                    iconLeft="fas fa-filter"
                                    variant="indigo"
                                    textColor="white"
                                    onClick={() => setFiltrar(!filtrar)}
                                />
                            </div>
                        }
                    </div>
                    {!filtro &&
                        <div className="flex items-end fade-in mb-2">
                            {faixa &&
                                <button onClick={() => { setFiltrar(!filtrar); setFaixa(""); localStorage.removeItem('faixa') }} className="bg-muted hover:bg-muted/70 border border-border px-4 py-2 rounded-md flex items-center mx-1 transition-colors duration-150">
                                    {faixa}  <i className="fas fa-times ml-2"></i>
                                </button>
                            }
                            {status &&
                                <button onClick={() => { setFiltrar(!filtrar); setStatus(""); localStorage.removeItem('status') }} className="bg-muted hover:bg-muted/70 border border-border px-4 py-2 rounded-md flex items-center mx-1 transition-colors duration-150">
                                    {status}  <i className="fas fa-times ml-2"></i>
                                </button>
                            }
                            {departamento &&
                                <button onClick={() => { setFiltrar(!filtrar); setDepartamento(""); localStorage.removeItem('departamento') }} className="bg-muted hover:bg-muted/70 border border-border px-4 py-2 rounded-md flex items-center mx-1 transition-colors duration-150">
                                    {departamento}  <i className="fas fa-times ml-2"></i>
                                </button>
                            }
                            {filial &&
                                <button onClick={() => { setFiltrar(!filtrar); setFilial(""); localStorage.removeItem('filial') }} className="bg-muted hover:bg-muted/70 border border-border px-4 py-2 rounded-md flex items-center mx-1 transition-colors duration-150">
                                    {filial}  <i className="fas fa-times ml-2"></i>
                                </button>
                            }
                            {solicitante &&
                                <button onClick={() => { setFiltrar(!filtrar); setSolicitante(""); localStorage.removeItem('solicitante') }} className="bg-muted hover:bg-muted/70 border border-border px-4 py-2 rounded-md flex items-center mx-1 transition-colors duration-150">
                                    {solicitante}  <i className="fas fa-times ml-2"></i>
                                </button>
                            }

                            <SplitButton
                                label="Exportar PDF"
                                color="indigo"
                                textColor="white"
                                icon="fas fa-file-pdf"
                                onClick={() => {
                                    const title = "Relatório de Solicitação de Compras ";
                                    const subtitle = (formatLocalDate(dataInicial)) + " a " + (formatLocalDate(dataFinal));
                                    exportaComQualidade(['lancamento-despesa-container'], title, subtitle)
                                }}
                                items={[
                                    {
                                        label: "Baixar Imagem",
                                        icon: "fas fa-camera",
                                        onClick: () => {
                                            captureElementToImage("lancamento-despesa-container");
                                        },
                                    },
                                    {
                                        label: "Copiar Imagem",
                                        icon: "fas fa-clipboard",
                                        onClick: () => {
                                            copyElementToClipboard("lancamento-despesa-container");
                                        },
                                    },
                                    {
                                        label: "Sincronizar com Fluig",
                                        icon: "fas fa-sync ",
                                        onClick: () => {
                                            despesaService.sincronismoManual().then(() => {
                                                toast.success("Todos os dados do Fluig foram atualizados! ");
                                                setFiltrar(!filtrar)
                                            }).catch(e => {
                                                console.error("Erro ao sincronizar: ", e)
                                            })
                                        },
                                    },
                                ]} />
                        </div>
                    }
                </div>
            </div>
            <div id='lancamento-despesa-container'>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2 mb-2">
                    <div className="bg-card border border-border rounded-lg shadow-card overflow-hidden transition-all duration-300 card-hover">
                        <div className="p-4">
                            <div className="flex justify-between items-center">
                                <div>
                                    <p className="text-sm font-medium text-muted-foreground">Solicitações Finalizadas</p>
                                    {loading ?
                                        <div role="status" className="max-w-sm animate-pulse">
                                            <div className="h-8 bg-muted rounded-full mt-1 w-32"></div>
                                        </div>
                                        :
                                        <h3 className="text-lg font-display font-bold text-foreground mt-1">{despesas.countByStatus?.Finalizado || '0'}</h3>
                                    }
                                </div>
                                <div className="bg-primary/10 p-3 rounded-full">
                                    <i className="fas fa-file-alt text-primary text-xl"></i>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="bg-card border border-border rounded-lg shadow-card overflow-hidden transition-all duration-300 card-hover">
                        <div className="p-4">
                            <div className="flex justify-between items-center">
                                <div>
                                    <p className="text-sm font-medium text-muted-foreground">Solicitações Pendentes</p>
                                    {loading ?
                                        <div role="status" className="max-w-sm animate-pulse">
                                            <div className="h-8 bg-muted rounded-full mt-1 w-32"></div>
                                        </div>
                                        :
                                        <h3 className="text-lg font-display font-bold text-foreground mt-1">{despesas.countByStatus?.Aberto || '0'}</h3>
                                    }
                                </div>
                                <div className="bg-yellow-100 p-3 rounded-full">
                                    <i className="fas fa-clock text-yellow-600 text-xl"></i>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="bg-card border border-border rounded-lg shadow-card overflow-hidden transition-all duration-300 card-hover">
                        <div className="p-4">
                            <div className="flex justify-between items-center">
                                <div>
                                    <p className="text-sm font-medium text-muted-foreground">Solicitações Canceladas</p>
                                    {loading ?
                                        <div role="status" className="max-w-sm animate-pulse">
                                            <div className="h-8 bg-muted rounded-full mt-1 w-32"></div>
                                        </div>
                                        :
                                        <h3 className="text-lg font-display font-bold text-destructive mt-1">{despesas.countByStatus?.Cancelado || '0'}</h3>
                                    }
                                </div>
                                <div className="bg-destructive/10 p-3 rounded-full">
                                    <i className="fas fa-stopwatch text-destructive text-xl"></i>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="bg-card border border-border rounded-lg shadow-card overflow-hidden transition-all duration-300 card-hover">
                        <div className="p-4">
                            <div className="flex justify-between items-center">
                                <div>
                                    <p className="text-sm font-medium text-muted-foreground">Valor Faturado</p>
                                    {loading ?
                                        <div role="status" className="max-w-sm animate-pulse">
                                            <div className="h-8 bg-muted rounded-full mt-1 w-40"></div>
                                        </div>
                                        :
                                        <h3 className="text-lg font-display font-bold text-foreground mt-1">R$ {formatarMoedaBrasileira(despesas.valorTotal) || 0}</h3>
                                    }
                                </div>
                                <div className="bg-purple-100 p-3 rounded-full">
                                    <i className="fas fa-money-bill-wave text-purple-600 text-xl"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {!loading &&
                    <div className="flex flex-col gap-2 lg:grid lg:grid-cols-12 mb-2">
                        <div className='lg:col-span-8'>
                            <DespesaPorMes data={despesas} filtrar={filtrar} loading={loading} alterarFaixa={changeFaixa} />
                        </div>
                        <div className='lg:col-span-4'>
                            <ResumoStatus filtrar={filtrar} data={despesas} loading={loading} alterarStatus={changeStatus} />
                        </div>
                        <div className='lg:col-span-4'>
                            <RankingDepartamentos data={despesas} filtrar={filtrar} loading={loading} alterarDepartamento={changeDepartamento} />
                        </div>
                        <div className='lg:col-span-4'>
                            <ResumoPorFilial data={despesas} loading={loading} filtrar={filtrar} alterarFilial={changeFilial} />
                        </div>
                        <div className='lg:col-span-4'>
                            <ResumoDepartamento data={despesas} filtrar={filtrar} loading={loading} alterarDepartamento={changeDepartamento} />
                        </div>
                        <div className='lg:col-span-4'>
                        <SolicitcoesPorFaixaPreco data={despesas} filtrar={filtrar} loading={loading} alterarFaixa={changeFaixa} />
                        </div>
                        <div className='lg:col-span-8'>
                            <ResumoSolicitantes data={despesas} filtrar={filtrar} loading={loading} alterarSolicitante={changeSolicitante} />
                        </div>
                    </div>
                }
                <div id="metricas" className="grid grid-cols-1 lg:grid-cols-1 gap-2 mb-2">

                </div>
            </div>
            <div className="flex flex-col lg:flex-row gap-2 mb-2">
                <div className="lg:w-full bg-card border border-border rounded-lg shadow-card p-4 h-full" >
                    <div className="flex justify-between align-items-center mb-2">
                        <h3 className="text-lg font-display font-semibold text-foreground">Lista de Solicitações</h3>
                        <Button variant="green" disabled={loading} onClick={exportarExcel} label="Exportar" iconLeft="fas fa-file-excel" />
                    </div>
                    {loading ?
                        <Loading />
                        :
                        <TabelaSolicitacoes solicitacoes={despesas.solicitacoes} dataFinal={dataFinal} dataInicial={dataInicial} />
                    }
                </div>
            </div>
        </main>
    );
}

export default RelatorioDespesa;
